import { render, staticRenderFns } from "./edit-protocol-dialog.vue?vue&type=template&id=6bc8673e&scoped=true&"
import script from "./edit-protocol-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-protocol-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-protocol-dialog.vue?vue&type=style&index=0&id=6bc8673e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc8673e",
  null
  
)

export default component.exports